"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var Stepper_less_1 = __importDefault(require("./Stepper.less"));
var clamp = function (value, min, max) {
    var minClamped = typeof min === 'number' ? Math.max(value, min) : value;
    var maxClamped = typeof max === 'number' ? Math.min(minClamped, max) : minClamped;
    return maxClamped;
};
var Stepper = function (_a) {
    var className = _a.className, label = _a.label, value = _a.value, unit = _a.unit, step = _a.step, min = _a.min, max = _a.max, disabled = _a.disabled, onChange = _a.onChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var localValue = (0, react_1.useRef)(value);
    var interval = (0, common_1.useInterval)(100);
    var timeout = (0, common_1.useTimeout)(250);
    var cancel = function () {
        interval.cancel();
        timeout.cancel();
    };
    var updateValue = (0, react_1.useCallback)(function (delta) {
        onChange(clamp(localValue.current + delta, min, max));
    }, [onChange]);
    var onDecrementMouseDown = (0, react_1.useCallback)(function () {
        cancel();
        timeout.start(function () { return interval.start(function () { return updateValue(-step); }); });
    }, [updateValue]);
    var onDecrementMouseUp = (0, react_1.useCallback)(function () {
        cancel();
        updateValue(-step);
    }, [updateValue]);
    var onIncrementMouseDown = (0, react_1.useCallback)(function () {
        cancel();
        timeout.start(function () { return interval.start(function () { return updateValue(step); }); });
    }, [updateValue]);
    var onIncrementMouseUp = (0, react_1.useCallback)(function () {
        cancel();
        updateValue(step);
    }, [updateValue]);
    (0, react_1.useEffect)(function () {
        localValue.current = value;
    }, [value]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Stepper_less_1.default['stepper'], className) },
        react_1.default.createElement("div", { className: Stepper_less_1.default['header'] }, t(label)),
        react_1.default.createElement("div", { className: Stepper_less_1.default['content'] },
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Stepper_less_1.default['button'], { 'disabled': disabled }), onMouseDown: onDecrementMouseDown, onMouseUp: onDecrementMouseUp, onMouseLeave: cancel },
                react_1.default.createElement(react_2.default, { className: Stepper_less_1.default['icon'], name: 'remove' })),
            react_1.default.createElement("div", { className: Stepper_less_1.default['value'] }, disabled ? '--' : "".concat(value).concat(unit)),
            react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Stepper_less_1.default['button'], { 'disabled': disabled }), onMouseDown: onIncrementMouseDown, onMouseUp: onIncrementMouseUp, onMouseLeave: cancel },
                react_1.default.createElement(react_2.default, { className: Stepper_less_1.default['icon'], name: 'add' })))));
};
exports.default = Stepper;
